import { useContext } from 'react';
import { UploadFilesContext } from './UploadContextProvider';

export const useUploadContext = () => {
    const uploadContext = useContext(UploadFilesContext);

    if (!uploadContext) {
        throw new Error(
            'useCurrentUser has to be used within <CurrentUserContext.Provider>'
        );
    }

    return uploadContext;
};